// extracted by mini-css-extract-plugin
export default {"termsConditions":"_63bb5513","tabs":"_a7ab743f","tabLabel":"_fc1bc31f","tabContent":"_4e5753ed"};